import React from "react";
import { SupportUnreadSummary } from "../../services/supportTicket.service";
import { ChatIcon } from "./ChatPanel";

interface Props {
  summary: SupportUnreadSummary;
  /** Who the messages are from, for the copy: "the support team" / "clinics". */
  from: string;
  onOpen?: (ticketId: string) => void;
  /** Dismiss = mark everything read. The banner stays until this is clicked. */
  onDismiss: () => void;
}

/** Persistent banner for unread support messages; only the ✕ (or opening the chat) clears it. */
export const SupportBanner: React.FC<Props> = ({ summary, from, onOpen, onDismiss }) => {
  if (summary.total === 0) return null;
  const first = summary.tickets[0];
  const ticketCount = summary.tickets.length;
  return (
    <div role="status" className="mb-4 flex items-start gap-3 rounded-xl border-2 border-sky-300 bg-sky-100 px-4 py-3 text-sm text-sky-900 shadow-sm">
      <span className="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-sky-600 text-white"><ChatIcon /></span>
      <div className="min-w-0 flex-1">
        <p className="font-semibold">
          {summary.total} new message{summary.total > 1 ? "s" : ""} from {from}
        </p>
        <p className="truncate text-xs text-sky-800">
          {ticketCount === 1 ? `On “${first.subject}”` : `Across ${ticketCount} tickets, latest: “${first.subject}”`}
          {first.clinic_name ? ` · ${first.clinic_name}` : ""}
        </p>
      </div>
      {onOpen && (
        <button
          type="button"
          onClick={() => onOpen(first.ticket_id)}
          className="flex-shrink-0 rounded-lg bg-sky-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-sky-700"
        >
          Open chat
        </button>
      )}
      <button type="button" onClick={onDismiss} className="flex-shrink-0 text-sky-700 hover:text-sky-900" aria-label="Dismiss">✕</button>
    </div>
  );
};
